var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userRow"},[_c('div',{staticClass:"avatar",class:{'bot-avatar' : _vm.isBot}}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.nickName))]),_vm._v(" "),(_vm.isBot)?_c('div',{staticClass:"bot"},[_vm._v("Bot")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73eb4723","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User-List/UserRow.vue
// module id = 96
// module chunks = 0